import BulkShippingOrderSummaryPrint from './BulkShippingOrderSummaryPrint';

export default BulkShippingOrderSummaryPrint;
